import {
  Component,
  effect,
  ElementRef,
  inject,
  Injectable,
  InjectionToken,
  input,
  output,
  ViewChild
} from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

export const PAGINATOR_LABEL = new InjectionToken<string>('paginator_label');


@Injectable()
export class CustomPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  // For internationalization, the `$localize` function from
  // the `@angular/localize` package can be used.
  firstPageLabel = `First page`;
  itemsPerPageLabel = inject(PAGINATOR_LABEL);
  lastPageLabel = `Last page`;

  // You can set labels to an arbitrary string too, or dynamically compute
  // it through other third-party internationalization libraries.
  nextPageLabel = 'Next page';
  previousPageLabel = 'Previous page';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `Page 1 of 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `Page ${page + 1} of ${amountPages}`;
  }
}

@Component({
  selector: 'app-custom-paginator',
  imports: [
    MatPaginator
  ],
  providers: [
    {provide: MatPaginatorIntl, useClass: CustomPaginatorIntl}
  ],
  templateUrl: './custom-paginator.html',
  styleUrl: './custom-paginator.scss'
})
export class CustomPaginator {
  total = input<number>(0);
  index = input(0);
  pageChanged = output<{pageIndex: number; pageSize: number}>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('pageSelector', { static: true }) pageSelector!: ElementRef;

  constructor() {
    effect(() => {
      if (this.index() === 0) {
        this.pageSelector.nativeElement.value = '';
      }
    });
  }

  changePage(page: {pageIndex: number; pageSize: number}) {
    this.pageSelector.nativeElement.value = (page.pageIndex + 1).toString();
    this.pageChanged.emit(page);
  }

  setPage(val: string) {

    const value = parseInt(val) - 1;

    const maxPage = Math.floor(this.paginator.length / this.paginator.pageSize);

    if (isNaN(value) || value > maxPage || value < 0) {
      return;
    }

    this.paginator.pageIndex = value;
    this.pageChanged.emit({pageIndex: value, pageSize: this.paginator.pageSize});

  }

}
